import { Shader } from "./shader/shader";
import { Texture } from "./texture";
/**
 * La differenza tra Output e Texture è che per Output viene chiamato
 * il metodo update() ad ogni tick del synth, per le texture no.
 * Ad un Output può essere associato uno shader oppure generare uno shader custom oppure
 * quello di default. Se il generator è presente significa che è quello di default.
 */
class Output extends Texture {
    constructor(synth, props = {}) {
        super(synth, { ...props, renderbuffer: true }, false);
    }
    generate(fragmentGenerator) {
        if (this.shader) {
            this.shader.clear();
            this.shader = null;
        }
        this.shader = new Shader(this.synth, {
            fragment: fragmentGenerator,
            name: "shader_" + this.name,
        });
        this.shader.out(this);
        this.shader.drawCalls = 0;
        this.activate();
    }
}
export { Output };
///////////////////////////
